
import { useCallback, useEffect, useState } from 'react'
import { Box, Grid } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */

/** API */

/** UTILS || SLICE */
import { showModal } from 'app/slice/modal.slice'

/** COMPONENT */
import { swalActive } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderCard from 'component/CardCustom/HeaderCard'

import InputTextSearch from 'component/Input/InputTextSearch'

import TableCustom from 'component/Table/TableCustom'
import { notiSuccess, notiError } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import FilterSelect from 'component/Select/FilterSelect'
import TableRowExport from 'component/Pdf/TableRowExport'
import useStyles from './style'
import ModalImageDoctorNote from './modal-image-doctor-note'
import ImageDoctorNoteApi, { IFImageDoctorNoteProps } from 'api/setting/doctor-note/image-doctor-note.api'
import _ from 'lodash'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'



export default function ImageDoctorNote() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const classes = useStyles()

    /** PAGINATION  */
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('createdAt')
    const [sortType, setSortType] = useState('ASC')
    const [search, setSearch] = useState('')
    const [status, setStatus] = useState('ALL')

    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const [statusAlertModal, setStatusAlertModal] = useState('')
    const [id, setId] = useState<number>(0)
    const [name, setName] = useState('')
    const [isOpenSnack, setIsOpenSnack] = useState(false)
    const [typeSnack, setTypeSnack] = useState<any>("success")
    const [labelSnack, setLabelSnack] = useState('')

    const [imageDoctorNotes, setImageDoctorNotes] = useState<[]>([])
    const [dataModal, setDataModal] = useState<{ isShow: boolean, data: any[] }>({ isShow: false, data: [] })

    const loadData = useCallback(async () => {
        let condition: any = {}
        if (page) condition = { ...condition, page: page }
        if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
        if (search) condition = { ...condition, search: search }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }
        if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }

        const res = await ImageDoctorNoteApi.findAll(condition)
        if (res.status === 200) {
            setRowCount(res.headers['x-total'])
            setImageDoctorNotes(res.data)
        }
    }, [page, pageLimit, search, sortBy, sortType, status])

    useEffect(() => {
        loadData()
    }, [loadData])



    const onActive = () => {
        if (id) {
            ImageDoctorNoteApi.updateStatus(id, statusAlertModal).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('IMAGE_DOCTOR_NOT.MESSAGE.SUCCESS.UPDATE_STATUS'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('IMAGE_DOCTOR_NOT.MESSAGE.ERROR'))
                }
            })
        }
    }
    const onDelete = () => {
        if (id) {
            ImageDoctorNoteApi.remove(id).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('IMAGE_DOCTOR_NOT.MESSAGE.SUCCESS.DELETE'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('IMAGE_DOCTOR_NOT.MESSAGE.ERROR'))
                }
            })
        }
    }

    const onCreate = () => {
        setDataModal({ isShow: true, data: [] })
        dispatch(showModal())
    }
    const onEdit = (data: any) => {
        setDataModal({ isShow: true, data })
        dispatch(showModal())
    }

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const handleChangePage = (val: number) => {
        setPage(val)
    }

    const handleChangeRowsPerPage = (limit: number) => {
        setPageLimit(limit)
    }
    const handleChangeStatus = (statusVal: string) => {
        setStatus(statusVal)
    }
    const resetPopup = () => {
        setDataModal({ isShow: false, data: [] })
        loadData()
    }
    const headCells = [
        { id: 'no', disablePadding: false, label: '#' },
        { id: 'treatmentCourseTypeName', disablePadding: false, label: t('IMAGE_DOCTOR_NOT.TABLE.CELL.IMAGE_DOCTOR_NOTE_NAME') },
        { id: 'templateFormName', disablePadding: false, label: t('IMAGE_DOCTOR_NOT.TABLE.CELL.IMAGE_DOCTOR_NOTE_NAME_EN') },
        { id: 'status', disablePadding: false, label: t('IMAGE_DOCTOR_NOT.TABLE.CELL.STATUS') },
        { id: 'updatedBy', disablePadding: false, label: t('IMAGE_DOCTOR_NOT.TABLE.CELL.UPDATED_BY') },
        { id: 'action', disablePadding: false, label: 'Action' }
    ]

    const renderData = (objData: IFImageDoctorNoteProps, no: number, valueExportData: boolean) => {
        const num = valueExportData === true ? no + 1 : page * pageLimit - pageLimit + no + 1
        const { doctorNoteImageId, name, doctorNoteType, updatedBy, updatedAt, status: dcTypeStatus }: IFImageDoctorNoteProps = objData
        const statusBtnActive = dcTypeStatus === 'ACTIVE' ? true : false
        const statusBtnInActive = dcTypeStatus === 'INACTIVE' ? true : false
        const objRenderData = {
            key: String(doctorNoteImageId),
            id: String(doctorNoteImageId),
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: num },
                { option: 'TEXT', align: 'left', label: doctorNoteType.typeName || '-' },
                { option: 'TEXT', align: 'left', label: name || '-' },
                { option: 'STATUS', align: 'center', label: dcTypeStatus },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
                {
                    option: 'ACTION',
                    align: 'center',
                    label: 'action',
                    values: [
                        { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
                        { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
                        { option: 'DIVIDER', label: '', disabled: false },
                        { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: false },
                        { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: false }
                    ]
                }
            ]
        }
        return (
            <>
                {valueExportData === true && <TableRowExport {...objRenderData} /> ||
                    <TableRowCommon
                        {...objRenderData}
                        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
                        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
                        onedit={() => onEdit(objRenderData.obj)}
                        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
                    />
                }
            </>
        )
    }

    const handleSubmitModal = (id: number, status: string, obj?: any) => {
        setStatusAlertModal(status)
        setId(id)
        setIsOpenAlertModal(true)
        setName(obj.name)
    }

    return (
        <div className={classes.root}>
            <AlertModal
                isOpen={isOpenAlertModal}
                title={t(`IMAGE_DOCTOR_NOT.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
                message={t(`IMAGE_DOCTOR_NOT.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { name: name, status: t(`IMAGE_DOCTOR_NOT.ALERT.${statusAlertModal}`) })}
                type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
                onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
            />
            <SnackbarComponent
                onOpen={isOpenSnack}
                onClose={() => setIsOpenSnack(false)}
                label={labelSnack}
                type={typeSnack}
                transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
                autoHideTime={3000}
            />
            <Box className="" sx={{ display: 'flex', flexDirection: 'column', backgroundColor: '#fff', borderRadius: '0.25rem', height: '100%' }}>
                <HeaderCard text={t('IMAGE_DOCTOR_NOT.TITLE')} />
                <Box sx={{ flex: '1 1 auto', p: '16px' }}>
                    <Box sx={{ mb: 0, pl: { xl: '16px' } }}>
                        <Grid container sx={{ alignItems: 'center' }}>
                            <Grid item md={8}>
                                <Grid container className="flax-row">
                                    <Grid item sm={12} md={6} xl={4} sx={{ pt: '8px' }}>
                                        <InputTextSearch
                                            keyInput={'search'}
                                            label={t('IMAGE_DOCTOR_NOT.SEARCH')}
                                            value={search}
                                            onchange={(event) => {
                                                setSearch(event.target.value)
                                                setPage(1)
                                            }}
                                            onClear={(event) => {
                                                setSearch('')
                                                setPage(1)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={6} xl={4} sx={{ pl: { md: 0 }, pt: '8px' }}>
                                        <FilterSelect
                                            onchange={(event) => {
                                                const value = event.target.value
                                                if (value) {
                                                    handleChangeStatus(value)
                                                    setPage(1)
                                                }
                                            }}
                                            renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                                            label={t('STATUS.LABEL')}
                                            selectId="select-status"
                                            value={status}
                                            labelId="label-status"
                                            options={[
                                                <MenuItem key="1" value="ALL">
                                                    {t('STATUS.ALL')}
                                                </MenuItem>,
                                                <MenuItem key="2" value="ACTIVE">
                                                    {t('STATUS.ACTIVE')}
                                                </MenuItem>,
                                                <MenuItem key="3" value="INACTIVE">
                                                    {t('STATUS.INACTIVE')}
                                                </MenuItem>
                                            ]}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item md={4} style={{ paddingLeft: 0 }} sx={{ mt: { xs: '8px', md: 'auto' } }}>
                                <Box sx={{ pr: { xl: '8px' }, display: 'flex' }}>
                                    <Box sx={{ ml: 'auto' }}>
                                        <ButtonCustom style={{ width: '260px' }} mode="add" onClick={onCreate} textButton={t('IMAGE_DOCTOR_NOT.BUTTON.ADD')} className="w-auto ml-auto d-flex mt-auto" btnStyle={{ height: '44px' }} />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    <div className={'mt-3 pl-xl-3 pr-xl-2'}>
                        <TableCustom
                            page={page}
                            pageLimit={pageLimit}
                            sortType={sortType}
                            sortBy={sortBy}
                            onSort={onRequestSort}
                            setPageLimit={handleChangeRowsPerPage}
                            setPage={handleChangePage}
                            rowCount={rowCount}
                            headCells={headCells}
                            rowsData={_.map(imageDoctorNotes, renderData)}
                        />
                    </div>
                </Box>
            </Box>

            <ModalImageDoctorNote  {...dataModal} callback={loadData} resetPopup={resetPopup} />
        </div>
    )
}
